export default __webpack_public_path__ + "static/media/back-arrow.d7f96318.svg";